import BusinessNotes from './BusinessNotes'

export default BusinessNotes
